import { RootPage } from '../page';
import $api from '../../api';
import { ProjectModel } from '../../models/Gen/BaseModels';
import IntroWizarView from './introWizardView';
import { checkExtensionIsInstalledAsync, getExtensionDownloadLink } from '../../components/extensionTester';

class DashboardOverviewView extends RootPage {
    constructor() {
        super();

        IntroWizarView(this);

        this.project = ko.observable();
        this.isReceiving = ko.observable();
        this.advisor = ko.observable();
        this.isExtensionInstalled = ko.observable();

        this.chromeExtensionDownloadLink = getExtensionDownloadLink();
    }

    onInit() {
        this.isReceiving(this.getServerSideData('isReceiving'));

        if (this.getServerSideData('isOnlyExtensionInstallation')) {
            checkExtensionIsInstalledAsync().then(res => {
                this.globalExtensionWarning(!res);
                this.shouldInstallExtension(!res);
            });
        } else {
            this.globalExtensionWarning(false);
            this.shouldInstallExtension(false);
        }

        checkExtensionIsInstalledAsync().then(res => {
            this.isExtensionInstalled(res);
        });

        //$api.advisor.getOverview(
        //    { projectCode: auth.project.UniqueCode },
        //    {},
        //    (resp) => {
        //        //console.log('OVERV', resp);
        //        this.advisor(resp);
        //    }
        //);
    }

    //sendExtension() {
    //    this.startSubmitting('userMails');
    //    $api.projects.sendExtensionInfo(
    //        { projectCode: auth.project.UniqueCode },
    //        { targetEmails: this.userMails() },
    //        (resp) => {
    //            this.stopSubmitting('userMails');
    //            this.showToast('E-mail sent!');
    //        }
    //    );
    //}

    skipInstallation() {
        TRACK_EVENT('Projects', 'Installation Wizard Skipped');

        $api.projects.setIsInstalled(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                window.location.reload();
            }
        );
    }

    finishInstallation() {
        TRACK_EVENT('Projects', 'Installation Wizard Finished');

        $api.projects.setIsInstalled(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                window.location.reload();
            }
        );
    }

    refreshIsReceiving() {
        $api.projects.isReceiving(
            { projectCode: auth.project.UniqueCode },
            {},
            (r) => {
                this.isReceiving(r.isReceiving);
            }
        );
    }
}

export default DashboardOverviewView;